import {
    Directive,
    Output, EventEmitter, HostListener, Input, ElementRef,Inject
} from '@angular/core';
import { TgBot } from '@app/core/models/models';
@Directive({
    selector: '[swipeClose]',
})
export class SwipeCloseDirective {

    private touchStart: number = 0;
    private touchCur: number = 0;
    private touchEnd: number = 0;
    @Input('swipeClose') media!: number;
    @Input('swipeParent') parent: boolean = false;

    @Output() close: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        private el: ElementRef,
        @Inject('TGBOT')
        private bot: TgBot
    ) {
        this.bot.WebApp.onEvent('viewportChanged',(e:any)=>{
            this.close.emit();
        })
    }

    @HostListener('touchstart', [ '$event' ])
    start(event: TouchEvent) {
        event.stopPropagation()
        if (globalThis.innerWidth < this.media) {
            this.touchStart = event.changedTouches[0].screenY;
            this.touchCur = 0;
        }
    }

    @HostListener('touchmove', [ '$event' ])
    move(event: TouchEvent) {
        event.stopPropagation()
        if (globalThis.innerWidth < this.media) {
            this.touchCur = event.changedTouches[0].screenY;
            if (this.touchCur > this.touchStart) {
                this.el.nativeElement[!this.parent ? '' : 'parentElement'].style.transform = `translate(0, ${ (this.touchCur - this.touchStart) }px)`;
            }
        }
    }

    @HostListener('touchend', [ '$event' ])
    end(event: TouchEvent) {
        event.stopPropagation()
        if (this.touchStart && !this.touchCur) {
            this.close.emit();
            return;
        }
        if (globalThis.innerWidth < this.media) {
            this.touchEnd = event.changedTouches[0].screenY;
            let height = this.el.nativeElement[!this.parent ? '' : 'parentElement'].offsetHeight;
           if (this.touchEnd - this.touchStart > height / 4) {
                this.el.nativeElement[!this.parent ? '' : 'parentElement'].style.transform = '';
                this.close.emit();
           } else {
                this.el.nativeElement[!this.parent ? '' : 'parentElement'].style.transform = '';
           }
        }
    }
}
